import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { h1, h3 } from '../styled/typography';

export const StatList = styled.ul`
  padding-left: 0;
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};

  display: grid;

  ${breakpoint.tablet`

    ${({ $statLayout }) =>
      $statLayout === 'line' &&
      css`
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
      `}

    ${({ $statLayout }) =>
      $statLayout === 'grid' &&
      css`
        grid-row: auto auto;
        grid-template-columns: auto auto;
      `}
  `}
`;

export const Stat = styled.li`
  padding: ${({ theme }) => theme.spacing.medium};
  text-align: center;
  color: ${({ theme }) => theme.palette.white};
  list-style: none;
  margin-bottom: 0;

  ${({ $statLayout, $statIndex, theme }) =>
    $statLayout === 'line' &&
    css`
      background-color: ${($statIndex === 0 && theme.palette.darkBackground) ||
      ($statIndex === 1 && theme.palette.standardText) ||
      ($statIndex === 2 && theme.palette.altBackground)};
    `};

  ${({ $statLayout, $statIndex, $rowIndex, theme }) =>
    $statLayout === 'grid' &&
    css`
      background-color: ${$statIndex % 2 !== 0
        ? theme.palette.standardText
        : theme.palette.darkBackground};

      ${breakpoint.tablet`
        background-color: ${
          ($statIndex + $rowIndex) % 2 !== 0
            ? theme.palette.standardText
            : theme.palette.darkBackground
        };
      `};
    `};

  // Stat title
  span:first-child {
    ${h1};
    display: block;
    margin: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  // Stat subtitle
  span:nth-child(2) {
    ${h3};
    margin: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
    display: block;
  }

  a {
    color: ${({ theme }) => theme.palette.white};
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
